import axios from 'axios';

// Base URL configuration
const BASE_URL = 'https://backend.hoanglecf.com/api';
// const BASE_URL = 'http://localhost:5000/api'; // For development

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: BASE_URL,
  // 25s: chừa thời gian cho cold-start Passenger (app bị tắt khi nhàn rỗi rồi
  // spawn lại) — 10s cũ quá ngắn nên hay timeout ngay request đầu sau khi nhàn.
  timeout: 25000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (user && user.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const config = error.config;
    // Retry GET đúng 1 lần khi lỗi mạng/timeout (thường do cold-start Passenger
    // hoặc Atlas M0 chậm). GET là idempotent nên retry an toàn; KHÔNG retry
    // POST/PUT/PATCH/DELETE để tránh tạo phiếu trùng.
    const isRetriable =
      config &&
      config.method === 'get' &&
      (error.code === 'ECONNABORTED' || !error.response);
    if (isRetriable && !config._retried) {
      config._retried = true;
      await new Promise((r) => setTimeout(r, 800));
      return apiClient(config);
    }
    // Handle common errors
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
